const applicationInfo = {
    namespaced: true,
    state : {
        rePresciptSeq : '',
        application : {},
        petient : {},
        prescription : {}
    },
    getters: {
        getRePresciptSeq(state) {
            return state.rePresciptSeq
        },
        getApplication (state) {
            return state.application
        },
        getPetient (state) {
            return state.petient
        },
        getPrescription (state) {
            return state.prescription
        }
    },
    mutations: {
        setRePresciptSeq (state, payload) {
            state.rePresciptSeq = payload
        },
        setApplication (state, payload) {
            state.application = payload
        },
        setPetient (state, payload) {
            state.petient = payload
        },
        setPrescription (state, payload) {
            state.prescription = payload
        }
    },
    actions: {
        setRePresciptSeq ({commit}, payload) {
            commit('setRePresciptSeq', payload)
        },
        setApplication ({commit}, payload) {
            commit('setApplication', payload)
        },
        setPetient ({commit}, payload) {
            commit('setPetient', payload)
        },
        setPrescription ({commit}, payload) {
            commit('setPrescription', payload)
        },
        setClinicDoctorInfoInit ({commit}) {
            commit('setRePresciptSeq', '');
            commit('setApplication', {});
            commit('setPetient', {});
            commit('setPrescription', {});
        }
    }
}

export default applicationInfo